import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { toast } from 'react-toastify';
import PeopleIcon from '@material-ui/icons/People';
import SaveAlt from '@material-ui/icons/SaveAlt';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '~/components/Paper';
import Button from '~/components/Button';
import Table from '~/components/Table/Table';
import GridItem from '~/components/GridItem';
import InputDate from '~/components/Input/InputDate';
import GridContainer from '~/components/GridContainer';
import LinearProgress from '~/components/LinearProgress';
import tableStyles from '~/components/Table/Table/styles';
import InputControl from '~/components/Input/InputControl';
import InputSelect from '~/components/Input/InputSelect';
import InputSelectAsync from '~/components/Input/InputSelectAsync';
import TablePagination from '~/components/Table/TablePagination';
import Request from '~/providers/Request';
import toInt from '~/utils/Number/toInt';
import isPresent from '~/utils/isPresent';
import csvGenerator from '~/utils/csvGenerator';
import xlsxGenerator from '~/utils/xlsxGenerator';
import InputSwitch from '~/components/Input/InputSwitch';
import Chip from '@material-ui/core/Chip';
import LinkMaterial from '@material-ui/core/Link';
import { showPerson } from '~/config/routes';
import CurrentUser from '~/contexts/CurrentUser';
import Input from '@material-ui/core/Input';

import { fetchHolders } from '~/utils/fetchHolders';
import { fetchCardOwners } from '~/utils/fetchCardOwners';

const getwayOptions = [
  { id: 'cielo', name: 'Cielo' },
  { id: 'braspag', name: 'Braspag' },
];
const productOptions = [
  { id: 'all', name: 'Todos' },
  { id: 'protectCard', name: 'Cartão protegido' },
  { id: 'recurrence', name: 'Recorrência' },
  { id: 'transactionError', name: 'Erro na compra' },
  { id: 'onlyRenewed', name: 'Compras renovadas' },
];

function ReportsCielo() {
  const { t } = useTranslation();
  const classesTable = tableStyles();
  const { user } = useContext(CurrentUser);
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [totalReports, setTotalReports] = useState(0);
  const [ccNumber, setCcNumber] = useState('');
  const [tid, setTid] = useState('');
  const [userSelected, setUserSelected] = useState(null);
  const [dataInit, setDataInit] = useState(moment().startOf('month').format());
  const [dataEnd, setDataEnd] = useState(moment().endOf('month').format());
  const [notUsedDaysAfter, setNotUsedDaysAfter] = useState(false);
  const [notRenewedAfterAcquire, setNotRenewedAfterAcquire] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [getway, setGetway] = useState(getwayOptions[1]);
  const [product, setProduct] = useState(productOptions[0]);
  const [onlyRenewed, setOnlyRenewed] = useState(false);
  const [cardOwner, setCardOwner] = useState('');
  const trAttr = (attr) => t(`reportsCielo.attributes.${attr}`);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  async function generateFile(type) {
    const filters = {
      start: userSelected?.id ? null : dataInit,
      end: userSelected?.id ? null : dataEnd,
      cc_number: ccNumber,
      not_used_days_after: notUsedDaysAfter,
      not_renewed_after_acquire: notRenewedAfterAcquire,
      tid,
      getway: getway.id,
      product: product.id,
      user_id: userSelected?.id || '',
      all: true,
      onlyRenewed,
      card_owner: cardOwner?.id || '',
    };

    const report_name = `${getway.id}-${moment().format('DD-MM-YYYY-HH-mm')}`;
    try {
      const rows = [];

      rows.push(['RELATÓRIO TELEVIDA CIELO/BRASPAG']);
      rows.push(['']);

      rows.push([
        'Data Inicial do Relatório',
        `${moment(dataInit).format('DD/MM/YYYY HH:mm')}`,
      ]);
      rows.push([
        'Data Final do Relatório',
        `${moment(dataEnd).format('DD/MM/YYYY HH:mm')}`,
      ]);
      rows.push(['']);

      rows.push([
        trAttr('person_name'),
        trAttr('card_name'),
        trAttr('value'),
        trAttr('installments'),
        trAttr('InstallmentsValue'),
        trAttr('NumberOfLives'),
        trAttr('cc_number'),
        trAttr('created_at'),
        trAttr('approved_at'),
        trAttr('tid'),
        trAttr('product'),
        trAttr('productName'),
        trAttr('error_code'),
        trAttr('error_message'),
        trAttr('is_renewal'),
      ]);
      const { data } = await Request.get('/admin/report/cielo', filters, {
        normalizeJSON: false,
      });

      data.map((row) => {
        rows.push([
          row.user ? row.user.name : '',
          row.payer[0].Name,
          row?.recurrent_payment_id
            ? formatAmount(row.amount * row.installments, true)
            : formatAmount(row.amount, true),
          row?.recurrent_payment_id
            ? `1/${row.installments}`
            : row.installments,
          row?.recurrent_payment_id
            ? formatAmount(row.amount, true)
            : formatValueInstallments(row.amount, row.installments, true),
          row.quantity,
          row.card_reference,
          moment(row.created_at).format('DD/MM/YYYY HH:mm:ss'),
          moment(row.date_approved).format('DD/MM/YYYY HH:mm:ss'),
          row.tid,
          row.transaction_type
            ? trAttr('transactionError')
            : row.recurrent_payment_id
            ? trAttr('recurrence')
            : trAttr('protectCard'),
          row.product ? row.product.name : '',
          row.transaction_type,
          row.error_message,
          row.is_renewal ? 'Renovação' : 'Não Renovação',
        ]);

        return row;
      });

      rows.push(['']);

      rows.push(['Número de vendas', reports.length]);
      rows.push(['Valor total de venda(R$)', someTotalAmount()]);

      rows.push(['']);
      rows.push(['Relatório gerado por', user.name]);
      rows.push([
        'Relatório gerado em',
        `${moment().format('L')} - ${moment().format('LT')}`,
      ]);

      if (type === 'csv') csvGenerator(`${report_name}.csv`, [...rows]);
      else xlsxGenerator(`${report_name}.xlsx`, [...rows]);

      toast.success(`Arquivo ${type.toLocaleUpperCase()} gerado com sucesso!`);
    } catch (error) {
      console.log(error);
      toast.error(
        `Não foi possível gerar o arquivo ${type.toLocaleUpperCase()}`
      );
    }
  }

  async function getReports() {
    setLoading(true);
    const filters = {
      start: userSelected?.id ? null : dataInit,
      end: userSelected?.id ? null : dataEnd,
      cc_number: ccNumber,
      not_used_days_after: notUsedDaysAfter,
      not_renewed_after_acquire: notRenewedAfterAcquire,
      page: page + 1,
      per_page: rowsPerPage,
      tid: tid,
      getway: getway.id,
      product: product.id,
      user_id: userSelected?.id || '',
      onlyRenewed: onlyRenewed,
      card_owner: cardOwner?.id || '',
    };

    Request.get('/admin/report/cielo', filters, { normalizeJSON: false })
      .then((response) => {
        setLoading(false);
        setReports(response.data);
        setPage(toInt(response.meta.page) - 1);
        setTotalReports(toInt(response.meta.total));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  async function fetchParams() {
    const url = new URLSearchParams(window.location.search);
    const start = url.get('start');
    const end = url.get('end');

    if (isPresent(start)) {
      const startDate = moment(start);

      if (startDate.isValid()) {
        setDataInit(startDate.format());
      }
    }

    if (isPresent(end)) {
      const endDate = moment(end);

      if (endDate.isValid()) {
        setDataEnd(endDate.format());
      }
    }
  }

  useEffect(() => {
    if (dataInit && dataEnd) {
      getReports();
    }
  }, [
    notUsedDaysAfter,
    notRenewedAfterAcquire,
    page,
    ccNumber,
    rowsPerPage,
    tid,
    getway,
    product,
    userSelected,
    dataInit,
    dataEnd,
    onlyRenewed,
    cardOwner,
  ]);

  useEffect(() => {
    fetchParams();
  }, []);

  const formatAmount = (value, noCurrence = false) => {
    const valueString = value.toString();
    const position = valueString.length - 2;
    const output = [
      valueString.slice(0, position),
      '.',
      valueString.slice(position),
    ].join('');
    if (noCurrence) {
      return [
        valueString.slice(0, position),
        ',',
        valueString.slice(position),
      ].join('');
    }
    return Number(output).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL',
    });
  };

  const formatValueInstallments = (value, installments, noCurrence = false) => {
    const valueByInstalltaments = value / 100 / installments;
    const valueString = Number(valueByInstalltaments).toFixed(2).toString();
    if (noCurrence) {
      return valueString.replace('.', ',');
    }
    return Number(valueString).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL',
    });
  };

  const someTotalAmount = () => {
    let some = 0;
    reports.map((item) => {
      if (item.recurrent_payment_id) {
        some += Number(item.amount * item.installments);
      } else {
        some += Number(item.amount);
      }
    });
    return formatAmount(some);
  };

  return (
    <>
      <Paper
        Icon={PeopleIcon}
        iconColor="blue"
        title={trAttr('reports')}
        subtitle={trAttr('reports_description')}
      >
        <GridContainer>
          <GridItem sm={12} md={6} lg={6}>
            <InputControl
              value={ccNumber}
              name="cc_number"
              label={t('reportsCielo.attributes.cc_number')}
              inputComponent={Input}
              onChange={({ cc_number }) => setCcNumber(cc_number)}
            />
          </GridItem>
          <GridItem sm={12} md={6} lg={6}>
            <InputControl
              value={tid}
              name="tid"
              label={t('reportsCielo.attributes.tid')}
              inputComponent={Input}
              onChange={({ tid }) => setTid(tid)}
            />
          </GridItem>
          <GridItem item sm={12} md={6} lg={3}>
            <InputControl
              value={userSelected}
              name={'userSelected'}
              label={t('reportsCielo.attributes.holder')}
              inputComponent={InputSelectAsync}
              onChange={({ userSelected }) => setUserSelected(userSelected)}
              InputProps={{
                isClearable: true,
                handleFetch: fetchHolders,
                createEnabled: false,
              }}
            />
          </GridItem>
          <GridItem item sm={12} md={6} lg={3}>
            <InputControl
              value={cardOwner}
              name={'cardOwner'}
              label={'Dono do cartão'}
              inputComponent={InputSelectAsync}
              onChange={({ cardOwner }) => setCardOwner(cardOwner)}
              InputProps={{
                isClearable: true,
                handleFetch: fetchCardOwners,
                createEnabled: false,
              }}
            />
          </GridItem>
          <GridItem item sm={12} md={6} lg={3}>
            <InputControl
              name={'product'}
              label={'Produto'}
              value={product}
              inputComponent={InputSelect}
              onChange={({ product }) => {
                if (product.name === 'Compras renovadas') {
                  setOnlyRenewed(true);
                } else {
                  setOnlyRenewed(false);
                }
                setProduct(product);
              }}
              InputProps={{
                isClearable: false,
                options: productOptions,
              }}
            />
          </GridItem>
          <GridItem item sm={12} md={6} lg={3}>
            <InputControl
              name={'getway'}
              label={'Integração'}
              value={getway}
              inputComponent={InputSelect}
              onChange={({ getway }) => {
                setGetway(getway);
              }}
              InputProps={{
                isClearable: false,
                options: getwayOptions,
              }}
            />
          </GridItem>
          <GridItem sm={6} md={6} lg={4}>
            <InputControl
              value={dataInit}
              name="date"
              label={t('reportsCielo.extras.date_init')}
              inputComponent={InputDate}
              disabled={!!userSelected}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                if (userSelected) {
                  toast.warning(
                    'Não é possível filtrar por data quando um titular está selecionado.'
                  );
                  return;
                }
                setDataInit(moment(date).startOf('day').format());
              }}
            />
          </GridItem>
          <GridItem sm={6} md={6} lg={4}>
            <InputControl
              value={dataEnd}
              name="date"
              label={t('reportsCielo.extras.date_end')}
              inputComponent={InputDate}
              disabled={!!userSelected}
              InputProps={{
                type: 'date',
              }}
              onChange={(date) => {
                if (userSelected) {
                  toast.warning(
                    'Não é possível filtrar por data quando um titular está selecionado.'
                  );
                  return;
                }
                setDataEnd(moment(date).endOf('day').format());
              }}
            />
          </GridItem>
          <GridItem align="right">
            <Button
              color="second"
              onClick={() => {
                generateFile('csv');
              }}
            >
              {t('action.export_csv')} <SaveAlt />
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              color="orange"
              onClick={() => {
                generateFile('xlsx');
              }}
            >
              {t('action.export_xlsx')} <SaveAlt />
            </Button>
          </GridItem>
          <GridItem xs={12}>
            <InputSwitch
              label={t('reportsCielo.extras.notUsedDaysAfter')}
              value={notUsedDaysAfter}
              onChange={setNotUsedDaysAfter}
            />
            <InputSwitch
              label={t('reportsCielo.extras.notRenewedAfterAcquire')}
              value={notRenewedAfterAcquire}
              onChange={setNotRenewedAfterAcquire}
            />
          </GridItem>
        </GridContainer>

        <LinearProgress loading={loading} />

        <Table
          emptyData={reports.length === 0}
          loading={loading}
          columns={
            <>
              <TableCell className={classesTable.cell}>
                {trAttr('person_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('card_name')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('value')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('installments')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('InstallmentsValue')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('NumberOfLives')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('cc_number')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('created_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('approved_at')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('tid')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('product')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('productName')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('is_renewal')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('error_code')}
              </TableCell>
              <TableCell className={classesTable.cell}>
                {trAttr('error_message')}
              </TableCell>
            </>
          }
        >
          {reports.length > 0 &&
            reports.map((row) => {
              return (
                <TableRow
                  key={`${row.id}-${row.report_name}`}
                  hover
                  className={classesTable.row}
                >
                  <TableCell>
                    <Chip
                      label={row.user?.name}
                      component={LinkMaterial}
                      href={showPerson.reverse({ id: row.user?.id })}
                      style={{ cursor: 'pointer' }}
                      target="_blank"
                      color="primary"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{row.payer[0].Name}</TableCell>
                  <TableCell>
                    {row?.recurrent_payment_id
                      ? formatAmount(row.amount * row.installments)
                      : formatAmount(row.amount)}
                  </TableCell>
                  <TableCell>
                    {row?.recurrent_payment_id
                      ? `1/${row.installments}`
                      : row.installments}
                  </TableCell>
                  <TableCell>
                    {row?.recurrent_payment_id
                      ? formatAmount(row.amount)
                      : formatValueInstallments(row.amount, row.installments)}
                  </TableCell>
                  <TableCell>{row.quantity}</TableCell>
                  <TableCell>{row.card_reference}</TableCell>
                  <TableCell>
                    {moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    {moment(row.date_approved).format('DD/MM/YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell>{row.tid}</TableCell>
                  <TableCell>
                    {row.transaction_type
                      ? trAttr('transactionError')
                      : row.recurrent_payment_id
                      ? trAttr('recurrence')
                      : trAttr('protectCard')}
                  </TableCell>
                  <TableCell>{row.product ? row.product.name : ''}</TableCell>
                  <TableCell>
                    {!row.is_renewal &&
                      row.is_renewal_error === null &&
                      'Primeira compra'}
                    {row.is_renewal &&
                      row.is_renewal_error === false &&
                      'Renovado'}
                    {row.is_renewal &&
                      row.is_renewal_error === true &&
                      'Não renovado'}
                  </TableCell>
                  <TableCell>{row.transaction_type}</TableCell>
                  <TableCell>{row.error_message}</TableCell>
                </TableRow>
              );
            })}
        </Table>

        <LinearProgress loading={loading} />

        <TablePagination
          count={totalReports}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default ReportsCielo;
